import { render, staticRenderFns } from "./GoodsCreateForm.vue?vue&type=template&id=62feafd5&scoped=true"
import script from "./GoodsCreateForm.vue?vue&type=script&lang=js"
export * from "./GoodsCreateForm.vue?vue&type=script&lang=js"
import style0 from "./GoodsCreateForm.vue?vue&type=style&index=0&id=62feafd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62feafd5",
  null
  
)

export default component.exports